const CSP_NONCE_PLACEHOLDER = 'DhcnhD3khTMePgXw';

module.exports = { CSP_NONCE_PLACEHOLDER };
